// eslint-disable-next-line import/prefer-default-export
export const CHANGE_PAYMENT_TYPE = 'CHANGE_PAYMENT_TYPE';
